import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

import { Store } from '@ngrx/store';

import {
  FilterLocationType,
  FilterStoreActions,
  FilterStoreSelectors,
} from '@shared/components/search-layout/search-navbar/store/filter-store.slice';

@Component({
  selector: 'app-stored-filters-dialog',
  templateUrl: './stored-filters-dialog.component.html',
  styleUrls: ['./stored-filters-dialog.component.scss'],
})
export class StoredFiltersDialogComponent implements OnInit {
  storedFilters$ = this.store.select(FilterStoreSelectors.selectStoredFilter);
  storedFiltersLoading$ = this.store.select(
    FilterStoreSelectors.selectStoredFilterLoading
  );
  selectedStoredFilterId$ = this.store.select(
    FilterStoreSelectors.selectSelectedStoredFilterId
  );

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      type: FilterLocationType;
      searchAction: any;
      storedFilterUpdater: any;
    },
    private store: Store
  ) {}

  ngOnInit(): void {
    this.store.dispatch(
      FilterStoreActions.loadStoredFilters.trigger({
        request: {
          type: this.data.type,
        },
      })
    );
  }

  togglePinOnFilter(event: MouseEvent, filterId?: string): void {
    event.stopPropagation();
    if (filterId) {
      this.store.dispatch(
        FilterStoreActions.pinStoredFilter.trigger({
          request: { filterId: filterId },
        })
      );
    }
  }

  applyFilter(filterId?: string): void {
    if (filterId) {
      this.store.dispatch(
        FilterStoreActions.applyStoredFilter.trigger({
          request: {
            filterId: filterId,
            searchAction: this.data.searchAction,
            storedFilterUpdater: this.data.storedFilterUpdater,
          },
        })
      );
    }
  }

  deleteFilter(event: MouseEvent, filterId?: string): void {
    event.stopPropagation();
    if (filterId) {
      this.store.dispatch(
        FilterStoreActions.deleteStoredFilter.trigger({
          request: {
            filterId: filterId,
            storedFilterUpdater: this.data.storedFilterUpdater,
          },
        })
      );
    }
  }
}
